import LogRocket from 'logrocket';

import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { isRecaptchaEnabled } from './RecaptchaProvider.utils';

export function useRecaptcha() {
  if (!isRecaptchaEnabled()) {
    return [() => null, true];
  }
  const { executeRecaptcha } = useGoogleReCaptcha();
  const loaded = !!executeRecaptcha;

  const getToken = async (action) => {
    // recaptcha not ready
    if (!executeRecaptcha) {
      return null;
    }
    try {
      return await executeRecaptcha(action);
    } catch (e) {
      LogRocket.captureException(e);
      return null;
    }
  };

  return [getToken, loaded];
}
